import * as React from 'react';

import type { CSS } from '@project44/manifest-ds';

import { StyledIcon } from './Icon.styles';

export function Icon(
  props: React.PropsWithRef<React.SVGProps<SVGSVGElement>> & { css?: CSS },
) {
  const { viewBox = '0 0 24 24', ...other } = props;

  return (
    <StyledIcon
      {...other}
      focusable={false}
      role="img"
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
    />
  );
}
